import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class LastUrlInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const skipUrls = ['/auth/logout', '/auth/login'];

    // Get the last URL from sessionStorage
    const lastUrl = sessionStorage.getItem('lastUrl');

    // If the last URL is different from the current URL, save the current URL to sessionStorage
    if (lastUrl !== request.url && !skipUrls.includes(request.url)) {
      sessionStorage.setItem('lastUrl', request.url);
    }

    return next.handle(request);
  }
}
